// galeries


$('.filtres_galeries--term').on('click',function(e){
    var annee = $(this).data('annee');
    $('.filtres_galeries--term').removeClass('active');
    $(this).addClass('active');
    
    $('.galeries--item-container').hide();
    $('.galeries--item-container.' + annee + '').show();


});
$('.filtres_galeries--term.refresh').on('click',function(e){
    $('.filtres_galeries--term').addClass('active');
    $('.galeries--item-container').show();
});